var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-main"},[_c('div',{staticClass:"banner",style:({
      backgroundImage: `url('${_vm.BASE_URL}${_vm.weHeader.url}')`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
    })},[_c('div',{staticClass:"about-content"},[_c('h2',[_vm._v("关于我们")]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.weHeader.content)}})])]),_c('div',{staticClass:"choiceimg"},[_c('div',{staticClass:"banner-all"},_vm._l((_vm.aboutUsImgs.list),function(item,index){return _c('div',{key:index,staticClass:"priceImgs"},[(item.imageUrls)?_c('img',{attrs:{"src":_vm.BASE_URL + item.imageUrls}}):_vm._e()])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }